export default __webpack_public_path__ + "static/media/commercial_loans.eb739174.svg";